import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Hero() {
  return <section className="relative pt-12 pb-8 md:pt-16 md:pb-12 px-4 overflow-hidden" data-id="element-65">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-800 via-slate-900 to-slate-900 -z-10" data-id="element-66"></div>

      <div className="max-w-6xl mx-auto space-y-8" data-id="element-67">
        {/* Top - Badge + Title */}
        <div className="text-center" data-id="element-68">
          <FadeIn data-id="element-69">
            <h1 className="text-2xl md:text-4xl lg:text-5xl font-extrabold text-white leading-tight mb-0 text-balance max-w-4xl mx-auto" data-id="element-70">
              Ahorra meses de lectura y dolor de cabeza con esta guia de estudio
            </h1>
          </FadeIn>
        </div>

        {/* Bottom - Image + Description */}
        <div className="grid md:grid-cols-2 gap-8 items-center" data-id="element-71">
          {/* Left Column - Book Image */}
          <div data-id="element-72">
            <FadeIn delay={0.1} data-id="element-73">
              <div className="relative max-w-[70%] mx-auto group" data-id="element-74">
                <div className="absolute -inset-1 bg-gradient-to-r from-cyan-500 to-lime-500 rounded-2xl blur opacity-25 group-hover:opacity-50 transition duration-1000 group-hover:duration-200" data-id="element-75"></div>
                <a href="#compra" className="relative block" data-id="element-76">
                  <img src="https://cdn.magicpatterns.com/uploads/r5JbimjLC8x2tr2H25To9B/freepik_adaptame-la-foto-img2-a-m_2794129050-removebg-preview.png" alt="KinesioTapingPro Book Cover" className="w-full h-auto rounded-xl shadow-2xl transform transition-transform duration-500 hover:scale-[1.02]" data-id="element-77" />
                </a>
              </div>
            </FadeIn>
          </div>

          {/* Right Column - Description + CTA */}
          <div className="text-center md:text-left" data-id="element-78">
            <FadeIn delay={0.2} data-id="element-79">
              <p className="text-base md:text-lg text-slate-300 mb-8" data-id="element-80">
                La guia de estudio mas completa para kinesiotaping y todo lo que
                lo rodea, con todo listo para usar y maximizar tus resultados
                desde el primer dia
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-81">
              <Button href="#compra" className="w-full md:w-auto text-lg px-8 py-4" data-id="element-82">
                Quiero acceder a la guia 👇
              </Button>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}